import * as React from 'react';

import Text from 'crehana-ui/Text';
import { secondaryMain } from 'crehana-ui/styles/colors';

import HeartBorderLight from 'crehana-icons/HeartBorderLight';
import { ProductsContext } from 'Jsx/ContextApis/Products';
import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';

const TagMobile: React.FC<Partial<CourseCardProps>> = props => {
  const { wishlistState, toggleWishlistItem } = React.useContext(
    ProductsContext,
  );
  const {
    courseTag,
    inShoppingCart,
    prices,
    hideWishList,
    canEnroll,
    customToggleWishlistItem,
    originalId,
  } = props;
  const itsFree = prices && prices.price === 0;
  const renderWishlist =
    !inShoppingCart && !itsFree && !hideWishList && !canEnroll;
  const handleToggleWishlistItem =
    customToggleWishlistItem || toggleWishlistItem;
  const isInWishlist = wishlistState.items.find(
    el => el.originalId === originalId,
  );

  return courseTag ? (
    <div
      className="TagMobileProps flex mb-8 justify-between"
      css={`
        .tag {
          background-color: ${courseTag ? courseTag.backgroundColor : '#06f'};
          padding: ${courseTag && courseTag.icon
            ? '2px 6px 2px 2px'
            : '3px 9px'};
        }
      `}
    >
      <div>
        {courseTag.icon && (
          <div
            className="flex items-center justify-start"
            style={{
              backgroundColor: courseTag.backgroundColor || '',
              padding: '2px 4px',
            }}
          >
            <img
              src={courseTag.icon}
              alt={courseTag.textLabel as string}
              style={{
                width: 'auto',
                height: 15,
              }}
            />
          </div>
        )}
        <div className="tag">
          <Text
            type="caption"
            style={{
              color: courseTag.textColor || '',
            }}
            className="inline-block"
          >
            {courseTag.textLabel}
          </Text>
        </div>
      </div>
      {renderWishlist && (
        <div
          className="w-20 h-20 ml-4 flex cursor-pointer items-center justify-center"
          onClick={() => handleToggleWishlistItem(props)}
          onKeyPress={() => handleToggleWishlistItem(props)}
          css={`
            ${isInWishlist &&
              `
              svg path {
                fill: ${secondaryMain};
              },
            `}
          `}
        >
          <HeartBorderLight size={17} color={secondaryMain} />
        </div>
      )}
    </div>
  ) : null;
};

export default TagMobile;
